<template>
  <div>
    <b-row>
      <b-col
        v-for="(link, index) in rtsp.slice(0, 2)"
        :key="index"
        lg="6"
        md="6"
        sm="12"
      >
        <br>
        <b-card
          no-body
        >
          <video
            :id="'video' + index"
            style="width:759px; height:429px;"
            muted
            playsinline
            autoplay
          />
          <b-card-text class="btext">
            <div class="box">
              <span>{{ index+1 }}</span>
            </div>
            <span>
              <a>{{ name[index] }} </a>
            </span>
          </b-card-text>
        </b-card>
      </b-col>
      <b-col
        v-for="(link, index) in rtsp.slice(2, 5)"
        :key="index+2"
        lg="4"
        md="4"
        sm="12"
      >
        <br>
        <b-card
          no-body
        >
          <video
            :id="'video'+ (index + 2)"
            style="width:497px; height:281px;"
            muted
          />
          <b-card-text class="btext">
            <div class="box">
              <span>{{ index+3 }}</span>
            </div>
            <span>
              <a>{{ name[index+2] }} </a>
            </span>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </div>

</template>

<script>
import Hls from 'hls.js'
import {
  BRow, BCol, BCard, BCardText,
} from 'bootstrap-vue'
// import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
  },
  data() {
    return {
      rtspData: [],
      rtsp: [],
      name: [],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  async mounted() {
    // await this.getRTSPCCTV()
    await this.for()
    // this.interval = setInterval(async () => {
    //   await this.getRTSPCCTV()
    //   await this.for()
    // }, 300000)
  },
  methods: {
    // async getRTSPCCTV() {
    //   await axios
    //     .post('/getCCTVTotalDB', { department: this.userData.department })
    //     .then(response => {
    //       this.rtspData.splice(0)
    //       this.rtsp.splice(0)
    //       this.name.splice(0)
    //       this.rtspData = response.data
    //       this.rtspData.forEach(value => {
    //         this.rtsp.push(value.RTSP_HLS)
    //         this.name.push(value.Camera_Desc)
    //       })
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // },
    for() {
      setTimeout(() => this.rtsp.slice(0, 2).forEach((value, i) => {
        this.stream(value, i)
      }), 1000)
      setTimeout(() => this.rtsp.slice(2, 5).forEach((value, i) => {
        this.stream(value, i + 2)
      }), 1000)
    },
    stream(value, i) {
      this.hls = new Hls({
        lowLatencyMode: true,
        autoreconnect: true,
      })
      const video = document.querySelector(`#video${i}`)
      const videoSrc = value
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc
      } else if (Hls.isSupported()) {
        this.hls.loadSource(videoSrc)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      }
    },
  },
}
</script>

<style>
video {
  width:100%;
  max-width:100%;
  height:auto;
}
.box {
    /* Rectangle 3616 */
  position: absolute;
  width: 48px;
  height: 48px;
  font-size: 24px;
  text-align: center;
  background: linear-gradient(180deg, #99FBCA 0%, #00B058 40.42%);
  border-radius: 4px;
  padding: 15px;
}
.btext {
  /* Rectangle 4458 */
width: 486px;
height: 48px;
text-align: left  ;

}
span a {
    display:inline-block;
    padding:14px 55px
}
</style>
